import { render } from "./CreateTaskTemplate.vue?vue&type=template&id=5e86cafc"
import script from "./CreateTaskTemplate.vue?vue&type=script&lang=js"
export * from "./CreateTaskTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__